import { httpRequest } from "@/axios/axios-api";

export default {
  data() {
    return {
      questionCollectionList: [],
      videoCollectionList: [],
      selectedTab: 0, // 0：试题列表；1：视频列表
      currentPage: -1,
      pageSize: 50
    };
  },
  created: function() {
    // 加载收藏列表
    this.loadCollectionList(true);
  },
  methods: {
    async loadCollectionList(fromBegining) {
      // 根据收藏列表，加载对应数据
      if (fromBegining && this.selectedTab === 0) {
        this.currentPage = -1;
        this.questionCollectionList = [];
      }
      const url =
        this.selectedTab === 0
          ? "/app/answer/qust-collect-records"
          : "/app/course/collect/collects";
      let params = null;
      if (this.selectedTab === 0) {
        this.currentPage++;
        params = {
          currentPage: this.currentPage,
          pageSize: this.pageSize
        };
      }
      const res = await httpRequest(url, "get", params);
      if (res !== null && res !== undefined && res.code === 200) {
        if (this.selectedTab === 0) {
          this.questionCollectionList = this.questionCollectionList.concat(
            res.data.list
          );
        } else {
          this.videoCollectionList = res.data;
        }
      }
    },
    changeCollectionTab(tabIdx) {
      this.selectedTab = tabIdx;
      this.loadCollectionList(true);
    },
    go2PracticePage(queIdx) {
      const curQuestion = this.questionCollectionList[queIdx];
      this.$router.push({
        path: "/practiceLibExam",
        query: {
          libId: curQuestion.libId,
          eqId: curQuestion.eqId,
          answerType: 0
        }
      });
    },
    unlike(queIdx) {
      const _this = this;
      this.$confirm("确定取消该收藏吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          const curQuestion = _this.questionCollectionList[queIdx];
          const res = await httpRequest(
            "/app/answer/qust-collect-record/" + curQuestion.eqId,
            "put",
            null
          );
          if (res !== null && res !== undefined && res.code === 200) {
            _this.$message.success("已取消收藏");
            // 将该问题移除
            _this.questionCollectionList.splice(queIdx, 1);
          }
        })
        .catch(() => {});
    },
    getDurationStr(duration) {
      // 用秒，获取字符串形式
      const minStr =
        duration / 60 < 10
          ? "0" + parseInt(duration / 60)
          : parseInt(duration / 60);
      const secStr =
        duration % 60 < 10
          ? "0" + parseInt(duration % 60)
          : parseInt(duration % 60);
      return minStr + ":" + secStr;
    },
    unlikeVideo(videoIdx) {
      const _this = this;
      this.$confirm("确定取消该收藏吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          const curVideo = _this.videoCollectionList[videoIdx];
          const params = {
            vcId: curVideo.vcId,
            validFlag: false
          };
          const res = await httpRequest("/app/course/collect", "put", params);
          if (res !== null && res !== undefined && res.code === 200) {
            _this.$message.success("已取消收藏");
            // 将该视频移除
            _this.videoCollectionList.splice(videoIdx, 1);
          }
        })
        .catch(() => {});
    },
    go2VideoPage(videoIdx) {
      const curVideo = this.videoCollectionList[videoIdx];
      const arIdCandidates = [
        curVideo && curVideo.arId,
        curVideo && curVideo.apply && curVideo.apply.arId,
        curVideo && curVideo.video && curVideo.video.apply && curVideo.video.apply.arId
      ];
      const resolvedArId = arIdCandidates
        .map(item => Number(item))
        .find(item => Number.isFinite(item) && item > 0);
      const query = {
        vcId: curVideo.vcId,
        csId: curVideo.video.csId
      };
      if (resolvedArId) {
        query.arId = String(resolvedArId);
      }
      this.$router.push({
        path: "/videoCourse",
        query
      });
    }
  }
};
